import apiRequest from 'utils/api/apiRequest';
import * as URLS from './urls';

export const monitorRulesApi = {
  load: monitorId => apiRequest(URLS.MONITOR_RULES_LIST + `?monitorId=${monitorId}`),
  update: data => {
    const options = { method: 'post', data };
    return apiRequest(URLS.MONITOR_RULES_UPDATE, options);
  }
};
